import { cls } from '@/utils/cls';

/** @deprecated Use `Skeleton` from `@accure/ui` */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cls(
        'animate-pulse rounded-md bg-neutral-100 dark:bg-neutral-800',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
